import { render, staticRenderFns } from "./OsInternalUserForm.vue?vue&type=template&id=6b7a9dee&scoped=true"
import script from "./OsInternalUserForm.vue?vue&type=script&lang=ts"
export * from "./OsInternalUserForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a9dee",
  null
  
)

export default component.exports